angular.module('core')
    .service('dblAnalyticsApi', ['cancelableResourceFactory', '$state', 'customer', 'transformResponse', 'moment','$log', '$rootScope',
    function ($cancelableResourceFactory, $state, $customer, $transformResponse, $moment, $log, $rootScope) {

        var self = this;

        var analyticsUrl = '/a/events';
        var analyticsResource = $cancelableResourceFactory.createCacheableResource(null, analyticsUrl, {
            }, {
                save: {
                    url: analyticsUrl,
                    method: 'POST'
                }
            }
        );

        function convertToInt(inputStr) {
            var outInt = null;
            try {
                var i = parseInt(inputStr, 10);
                if(angular.isNumber(i) && isNaN(i) === false) {  // Note: Number.isNaN is not supported by IE 11 and some other browsers!
                    outInt = i;
                }
            }
            catch(e){
                console.log(e);
            }
            return outInt;

        }

        self.logEvent = function(event) {
            var resource = analyticsResource;

            var data = angular.copy(event);
            var state = angular.copy(event.state);
            var tracking = angular.copy(state.tracking);

            //flatten event object and remove nested items
            angular.extend(data, state, tracking);
            data.localTimestamp = new Date();
            delete(data.state);

            //make sure our Id's are all integers not strings
            data.districtId = convertToInt(data.districtId);
            data.schoolId = convertToInt(data.schoolId);
            data.classroomId = convertToInt(data.classroomId);
            data.teacherId = convertToInt(data.teacherId);
            data.trackingDurationInMs = convertToInt(data.trackingDurationInMs);

            resource.save(data);
            $rootScope.$emit('dbl-debug', angular.extend({ method: 'dblAnalyticsApi.logEvent'}, data));

            return null;
    };

}]);
